import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import UpdateIcon from "../../../components/shared/icon/UpdateIcon";
import DeleteIcon from "../../../components/shared/icon/DeleteIcon";
import useAppGlobal from "../../../context/useAppGlobal";
import ConfirmComp from "../../../components/shared/ConfirmComp";
import useBrandRemove from "../../../hooks/brands/useBrandRemove";
import { enqueueSnackbar } from "notistack";
import BrandCreate from "../BrandCreate";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
export default function useBrandAction() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog, closeDialog } = useAppGlobal();
  const [brandId, setBrandId] = useState();
  const { trigger: removeBrand } = useBrandRemove(brandId);

  const handleBrandUpdate = (item) => {
    handleOpenDialog({
      title: "Cập nhật thương hiệu",
      content: <BrandCreate item={item} />,
      size: "md",
    });
  };
  const handleBrandRemove = async (item) => {
    const res = await removeBrand({
      id: item?._id,
    });
    if (res?.success) {
      closeDialog();
      return enqueueSnackbar("Thành công!", { variant: "success" });
    } else {
      return enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };
  const action = [
    {
      id: uuid(),
      icon: <UpdateIcon />,
      onClick: (item) => handleBrandUpdate(item),
      type: "icon",
      disabled: !permissionCheck([PERMISSIONS.UPDATE_BRAND]),
    },
    {
      id: uuid(),
      icon: <DeleteIcon />,
      disabled: !permissionCheck([PERMISSIONS.DELETE_BRAND]),
      onClick: (item) => {
        setBrandId(item?._id);
        handleOpenDialog({
          content: (
            <ConfirmComp
              name={item?.name}
              onConfirm={() => handleBrandRemove(item?._id)}
            />
          ),
          size: "md",
        });
      },
      type: "icon",
    },
  ];
  return action;
}
